const AuthLoadingScreen = ({ message = "Loading…" }) => (
  <div className="midpoint-app auth-loading-screen">
    <div className="midpoint-state-card auth-loading-card">
      <p className="eyebrow">Midpoint</p>
      <h1>{message}</h1>
      <p className="muted">Verifying your session…</p>
    </div>
  </div>
);

export default AuthLoadingScreen;
